import getRange from './getRange';
import getStringFromArray from './getStringFromArray';

export default (days) => {
  if (!days.length) {
    return undefined;
  }
  const ranges = days
    .reduce((acc, curr, i) => {
      if (i === 0) {
        return [{ from: curr, to: curr }];
      }
      const currRange = acc[acc.length - 1];
      if (currRange.to === (curr - 1)) {
        currRange.to = curr;
        return acc;
      }
      return [...acc, { from: curr, to: curr }];
    }, [])
    .map((r) => getRange(r.from, r.to));

  if (ranges.length === 1) {
    return ranges[0];
  }

  return getStringFromArray(ranges, { lastJoiner: ' or ' });
};
